import {gql} from "@apollo/client";

export default gql`
  mutation preferWorker($data: PreferWorkerInput!) {
    preferWorker(data: $data) {
      workerId
    }
  }
`;
